module.exports = __webpack_public_path__ + "img/spoken-training-test-report-active.9db6968e.svg";